<template>
  <div>
    <v-toolbar id="toolbar" color="light-blue darken-4" dark app>
      <div class="hidden-md-and-up"> <!-- MOBILE -->
        <v-toolbar-side-icon @click="drawerMobile=!drawerMobile"></v-toolbar-side-icon>
      </div>
      <div class="hidden-sm-and-down"> <!-- DESKTOP -->
        <v-toolbar-side-icon @click="drawerDesktop=!drawerDesktop" v-if="isLoggedIn"></v-toolbar-side-icon>
      </div>

      <router-link class="link" to="/"><v-toolbar-title class="white--text">DecSpace <sub style="color: cyan;"><small>Pre-Alpha</small></sub></v-toolbar-title></router-link>
      <v-spacer></v-spacer>

      <div class="hidden-md-and-up"> <!-- MOBILE -->
        <router-link class="link" to="/signup" v-if="!isLoggedIn"><v-btn dark >Sign Up</v-btn></router-link>
        <router-link class="link" to="/login" v-if="!isLoggedIn"><v-btn dark >Login</v-btn></router-link>
        <v-btn dark v-on:click="logout()" v-if="isLoggedIn">Logout</v-btn>
      </div>
      <div class="hidden-sm-and-down"> <!-- DESKTOP -->
        <router-link class="link" to="/admin" v-if="isLoggedIn && $store.state.email==='admin@admin.com'"><v-btn flat>Administrator</v-btn></router-link>
        <router-link class="link" to="/publicprojects"><v-btn flat>Public Projects</v-btn></router-link>
        <router-link class="link" to="/method-catalog"><v-btn flat>Methods</v-btn></router-link>
        <router-link class="link" to="/faq"><v-btn flat>FAQ</v-btn></router-link>
        <router-link class="link" to="/ContactUs"><v-btn flat>Contact Us</v-btn></router-link>
        <router-link class="link" to="/signup" v-if="!isLoggedIn"><v-btn dark>Sign Up</v-btn></router-link>
        <router-link class="link" to="/login" v-if="!isLoggedIn"><v-btn dark>Login</v-btn></router-link>
        <v-btn dark v-on:click="logout()" v-if="isLoggedIn">Logout</v-btn>
      </div>
    </v-toolbar>
    
    <!-- MOBILE logged in -->
    <v-navigation-drawer class='mt-4' dark temporary fixed hide-overlay clipped style='top: 32px' v-model="drawerMobile" height="400px" v-if="isLoggedIn">
      <v-list class="pa-1">
        <v-list-tile avatar>
          <v-list-tile-avatar><v-avatar class="indigo"><v-icon dark>account_circle</v-icon></v-avatar></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title><i>{{ $store.state.user }}</i></v-list-tile-title></v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-list-tile v-for="item in drawerMobileItems" :to="item.link" :key="item.title">
          <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
          <v-list-tile-content><v-list-tile-title>{{ item.title }}</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <!-- MOBILE logged out -->
    <v-navigation-drawer class='mt-4' dark temporary fixed hide-overlay clipped style='top: 32px' v-model="drawerMobile" height="400px" v-if="!isLoggedIn">
      <v-list class="pa-1">
        <v-list-tile avatar>
          <v-list-tile-avatar><v-avatar class="indigo"><v-icon dark>account_circle</v-icon></v-avatar></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title><i>Anonymous</i></v-list-tile-title></v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-list-tile v-for="item in drawerMobileItemsLogout" :to="item.link" :key="item.title">
          <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
          <v-list-tile-content><v-list-tile-title>{{ item.title }}</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <!-- DESKTOP -->
    <v-navigation-drawer class='mt-5' dark temporary fixed hide-overlay clipped style='top: 16px' v-model="drawerDesktop" height="400px">
      <v-list class="pa-1">
        <v-list-tile avatar>
          <v-list-tile-avatar><v-avatar class="indigo"><v-icon dark>account_circle</v-icon></v-avatar></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title><i>{{ $store.state.user }}</i></v-list-tile-title></v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-list-tile v-for="item in drawerDesktopItems" :to="item.link" :key="item.title">
          <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
          <v-list-tile-content><v-list-tile-title> {{ item.title }}</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import {EventBus} from '@/event-bus.js'
  export default {
    data: function() {
      return {
        drawerDesktop: null,
        drawerMobile: null,
        drawerDesktopItems: [
          {title: 'My Projects', icon: 'star', link:"/myprojects"},
          {title: 'Settings', icon: 'settings', link:"/settings"}
        ],
        drawerMobileItems: [
          {title: 'Public Projects', icon: 'public', link:"/publicprojects"},
          {title: 'Method Catalog', icon: 'library_books', link:"/method-catalog"},
          {title: 'FAQ', icon: 'question_answer', link:"/faq"},
          {title: 'Contact Us', icon: 'contact_support', link:"/ContactUs"},
          {title: 'My Projects', icon: 'star', link:"/myprojects"},
          {title: 'Settings', icon: 'settings', link:"/settings"}
        ],
        drawerMobileItemsLogout: [
          {title: 'Public Projects', icon: 'public', link:"/publicprojects"},
          {title: 'Method Catalog', icon: 'library_books', link:"/method-catalog"},
          {title: 'FAQ', icon: 'question_answer', link:"/faq"},
          {title: 'Contact Us', icon: 'contact_support', link:"/ContactUs"}
        ]
      }
    },
    computed: {
      isLoggedIn: function () {
        return this.$store.state.token;
      }
    },
    methods: {
      logout() {
        this.$session.destroy();
        this.$store.dispatch('setEmail', null);
        this.$store.dispatch('setToken', null);
        this.$store.dispatch('setUser', null);
        EventBus.$emit('send-notification', {text: 'Logout successful', color: 'success'});
        this.$router.push('/');
      },
    }
  }
</script>

<style scoped>
  .link {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue